<template>
  <div>
    <v-row>
      <v-col cols="12 py-0">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col>
                <!-- Filters -->
                <v-row class="ma-0 align-right sub-section">
                  <TableFilters
                      :filters="[
                      'search',
                      'dateRange',
                      'orderstatus',
                      'biller'
                    ]"
                      v-model="filter"
                      :columns="columns"
                  ></TableFilters>
                  <ImportExportMenu></ImportExportMenu>
                </v-row>
                <!-- Data table -->
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                        :items-per-page="paginationOptions.perPage"
                        :headers="headers"
                        :items="orders"
                        :search="search"
                        hide-default-footer
                        :loading="loading"
                        loading-text="Loading... Please wait"
                    >
                      <template v-slot:no-data>
                        <div class="mt-16 container justify-center item-center">
                          <noData name="Orders" />
                        </div>
                      </template>
                      <template slot="body.append">
                        <tr
                            class="black--text"
                            v-if="total > 0"
                        >
                          <th class="title"></th>
                          <th class="title"></th>


                          <th>
                            <h3>  {{totalSales|formatCurrency

                              }}</h3>
                          </th>
                          <th  class="text-center">
                            <h3> {{discountAmount|formatCurrency}} </h3>
                          </th>
                          <th class="text-center">
                            <h3>  {{total|formatCurrency

                              }}</h3>
                          </th>
                          <th class=" text-right">
                            <h3>  </h3>
                          </th>
                        </tr>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-chip
                            :x-small="true"
                            class="ma-2"
                            label
                            text-color="white"
                            :color="GetReserveStatusColor(item.status)"
                            dark
                        >{{ item.status }}</v-chip
                        >
                      </template>
                      <template v-slot:item.user="{ item }">
                        {{ item.user ? item.user.first_name : "" }}
                      </template>
                      <template v-slot:item.date="{ item }">{{
                          item.date | formatDate
                        }}</template>

                      <template v-slot:item.amount="{ item }"> <strong class="px-4">{{
                          item.amount | formatCurrency
                        }}</strong></template>

                      <template v-slot:footer="{}">

                        <paginationComponent
                            @paginationOptions="setPaginationOptions"
                            :url="'hms/guests/' + orderId + '/reservations'"
                            :filter="filter"
                            @response="receivePurchaseResponse"
                        />
                      </template>
                      <template
                          slot="body.append"
                          v-if="OrderList && OrderList.length > 0"
                      >
                      </template> </v-data-table
                    ></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </div>
</template>

<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->
<script>
import datePickComponent from "../../../components/base/DateComponent.vue";

import paginationComponent from "../../shared/components/pagination.vue";
import TableFilters from "@/components/base/TableFilters";
import moment from "moment";

export default {
  data() {
    return {
      paginationOptions: {},
      loading: true,
      search: "",
      total: 0,
      totalSales:0,
      discountAmount:0,
      columns: [
        {
          text: "Date",
          value: "date",
          show: true,
          disabled: false,
          width: "16.5%",
        },
        {
          text: "Reference Number",
          value:"reference_number",
          show: true,
          disabled: false,
          width: "16.5%",
        },
        {
          text: "Total Amount",
          value: "total_amount",
          show: true,
          align: "left",
          disabled: false,
          width: "16.5%",
        },
        {
          text: "Paid Amount",
          value: "paid_amount",
          align: "center",
          show: true,
          disabled: false,
          width: "15%",
        },
         {
          text: "Order Total Amount",
          value: "order_total_amount",
          align: "center",
          show: true,
          disabled: false,
          width: "15%",
        },
         {
          text: "Room Total Amount",
          value: "room_total_amount",
          align: "center",
          show: true,
          disabled: false,
          width: "15%",
        },
        {
        text: "Reserved By",
        value: "user.last_name",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
        {
          text: "Status",
          value: "status",
          show: true,
          disabled: false,
          align: "center",
          width: "16.5%",
        },
      ],
      orders: [],
      GetReserveStatusColor(status) {
          
         switch (status) {
        case "Paid":
          return "green";
          break;
        case "partially_paid":
          return "orange";
          break;
        case "Canceled":
          return "red";
          break;
        default:
          break;
      }
      },
      filter: {

        start: "",
        end: "",
        search: "",
      status: "",
      },
      date_range: [],
    };
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    receivePurchaseResponse(orders) {
        
      this.orders = orders;

    //   this.total = this.sumField(this.payment, "paid_amount");
    //   this.totalSales=this.sumField(this.payment,'grand_total')
    //   this.discountAmount=this.sumField(this.payment,'discount_amount')
      this.loading = false;
    },
    clearFilter() {
      this.filter = {};
    },
    SetSuplierId() {
      this.orderId = this.$route.params.id;
    },
    startDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    
    sumField(array, filed) {
      
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
  },

  mounted() {},

  components: {
    datePickComponent,
    paginationComponent,
    TableFilters,
  },
  created() {
    this.SetSuplierId();
  },

  computed: {
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(" ~ ");
    },
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
<style scoped></style>
